/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _circle, _path2, _path3, _path4, _circle2, _path5, _path6, _path7, _circle3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _circle4, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _circle5, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _circle6, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _circle7, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _circle8, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _circle9, _path124, _path125, _path126, _path127, _circle10, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _circle11, _circle12, _circle13, _circle14, _path156, _path157, _path158, _circle15, _circle16, _circle17, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _circle18, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _circle19, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _circle20, _circle21, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216;
const DirectionRotaryFirstRight = /*#__PURE__*/React.forwardRef(function DirectionRotaryFirstRight(_ref, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,18v6.5859L15.8712,14.457A5.9242,5.9242,0,0,0,17,11a6,6,0,1,0-7,5.91V28h2V16.91a5.9566,5.9566,0,0,0,2.4554-1.04L24.5859,26H18v2H28V18ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryFirstRight.propTypes = iconPropTypes;
}
const DirectionRotaryFirstRightFilled = /*#__PURE__*/React.forwardRef(function DirectionRotaryFirstRightFilled(_ref2, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859l-8.833-8.833A4.9678,4.9678,0,0,1,12,15.8989V26H10V15.8989a5.0113,5.0113,0,1,1,5.167-2.146L24,22.5859V16h2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Zm13,2v6.5859l-8.833-8.833A4.9959,4.9959,0,1,0,10,15.8989V26h2V15.8989a4.9678,4.9678,0,0,0,1.7529-.7319L22.5859,24H16v2H26V16Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryFirstRightFilled.propTypes = iconPropTypes;
}
const DirectionRotaryRight = /*#__PURE__*/React.forwardRef(function DirectionRotaryRight(_ref3, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4,20.5859,5.4141,25.1719,10H16.91A5.9965,5.9965,0,1,0,10,16.91V28h2V16.91A6.0061,6.0061,0,0,0,16.91,12h8.2622l-4.586,4.5859L22,18l7-7ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryRight.propTypes = iconPropTypes;
}
const DirectionRotaryRightFilled = /*#__PURE__*/React.forwardRef(function DirectionRotaryRightFilled(_ref4, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,18l-1.4141-1.4141L23.1719,12h-7.273A5.0145,5.0145,0,0,1,12,15.8989V26H10V15.8989A5,5,0,1,1,15.8989,10h7.273l-4.586-4.5859L20,4l7,7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20,4,18.5859,5.4141,23.1719,10h-7.273A5,5,0,1,0,10,15.8989V26h2V15.8989A5.0145,5.0145,0,0,0,15.8989,12h7.273l-4.586,4.5859L20,18l7-7ZM11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryRightFilled.propTypes = iconPropTypes;
}
const DirectionRotaryStraight = /*#__PURE__*/React.forwardRef(function DirectionRotaryStraight(_ref5, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17,12.09V5.8281l4.5859,4.586L23,9,16,2,9,9l1.4141,1.4141L15,5.8281V12.09A5.9925,5.9925,0,0,0,15,23.91V28h2V23.91A5.9925,5.9925,0,0,0,17,12.09ZM16,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryStraight.propTypes = iconPropTypes;
}
const DirectionRotaryStraightFilled = /*#__PURE__*/React.forwardRef(function DirectionRotaryStraightFilled(_ref6, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref6;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "19",
    r: "3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,12.4141,17,7.8281v6.273a5,5,0,0,1,0,9.7978V28H15V23.8989a5,5,0,0,1,0-9.7978V7.8281l-4.5859,4.586L9,11l7-7,7,7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.5859,12.4141,23,11,16,4,9,11l1.4141,1.4141L15,7.8281v6.273a5,5,0,0,0,0,9.7978V28h2V23.8989a5,5,0,0,0,0-9.7978V7.8281ZM19,19a3,3,0,1,1-3-3A3.0033,3.0033,0,0,1,19,19Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionRotaryStraightFilled.propTypes = iconPropTypes;
}
const DirectionSharpTurn = /*#__PURE__*/React.forwardRef(function DirectionSharpTurn(_ref7, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref7;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18v6.5859L7.707,6.293A1,1,0,0,0,6,7V28H8V9.4141L24.5859,26H18v2H28V18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionSharpTurn.propTypes = iconPropTypes;
}
const DirectionSharpTurnFilled = /*#__PURE__*/React.forwardRef(function DirectionSharpTurnFilled(_ref8, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref8;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionSharpTurnFilled.propTypes = iconPropTypes;
}
const DirectionStraight = /*#__PURE__*/React.forwardRef(function DirectionStraight(_ref9, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref9;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L9 11 10.414 12.414 15 7.828 15 28 17 28 17 7.828 21.586 12.414 23 11 16 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionStraight.propTypes = iconPropTypes;
}
const DirectionStraightFilled = /*#__PURE__*/React.forwardRef(function DirectionStraightFilled(_ref10, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref10;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionStraightFilled.propTypes = iconPropTypes;
}
const DirectionStraightRight = /*#__PURE__*/React.forwardRef(function DirectionStraightRight(_ref11, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref11;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16L21 9 19.586 10.414 24.172 15 4 15 4 17 24.172 17 19.586 21.586 21 23 28 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionStraightRight.propTypes = iconPropTypes;
}
const DirectionStraightRightFilled = /*#__PURE__*/React.forwardRef(function DirectionStraightRightFilled(_ref12, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionStraightRightFilled.propTypes = iconPropTypes;
}
const DirectionUTurn = /*#__PURE__*/React.forwardRef(function DirectionUTurn(_ref13, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref13;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5859,19.5859,22,24.1719V12A8,8,0,0,0,6,12V28H8V12a6,6,0,0,1,12,0V24.1719l-4.5859-4.586L14,21l7,7,7-7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionUTurn.propTypes = iconPropTypes;
}
const DirectionUTurnFilled = /*#__PURE__*/React.forwardRef(function DirectionUTurnFilled(_ref14, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref14;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.5859,17.5859,22,22.1719V14A8,8,0,0,0,6,14V26H8V14a6,6,0,0,1,12,0v8.1719l-4.5859-4.586L14,19l7,7,7-7Z",
    "data-icon-path": "inner-path"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21,26l-7-7,1.4141-1.4141L20,22.1719V14A6,6,0,0,0,8,14V26H6V14a8,8,0,0,1,16,0v8.1719l4.5859-4.586L28,19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectionUTurnFilled.propTypes = iconPropTypes;
}
const DirectoryDomain = /*#__PURE__*/React.forwardRef(function DirectoryDomain(_ref15, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref15;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H18.8157A2.9959,2.9959,0,0,0,17,24.1841V19h7a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,4V17a2.0025,2.0025,0,0,0,2,2h7v5.1841A2.9959,2.9959,0,0,0,13.1843,26H4v2h9.1843a2.982,2.982,0,0,0,5.6314,0H28ZM24,12H8V9H24Zm0-8V7H8V4ZM8,14H24v3H8Zm8,14a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DirectoryDomain.propTypes = iconPropTypes;
}
const DistributeHorizontalCenter = /*#__PURE__*/React.forwardRef(function DistributeHorizontalCenter(_ref16, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref16;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10H23V2H21v8H20a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h1v8h2V22h1a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0024 10zm0 10H20V12h4zM12 6H11V2H9V6H8A2.0023 2.0023 0 006 8V24a2.0023 2.0023 0 002 2H9v4h2V26h1a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0012 6zm0 18H8V8h4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeHorizontalCenter.propTypes = iconPropTypes;
}
const DistributeHorizontalLeft = /*#__PURE__*/React.forwardRef(function DistributeHorizontalLeft(_ref17, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref17;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22H24a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 22zM24 12v8h4V12zM18 2H20V30H18zM12 26H8a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 018 6h4a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 0112 26zM8 8V24h4V8zM2 2H4V30H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeHorizontalLeft.propTypes = iconPropTypes;
}
const DistributeHorizontalRight = /*#__PURE__*/React.forwardRef(function DistributeHorizontalRight(_ref18, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref18;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V30H28zM24 22H20a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0124 22zM20 12h-.0015L20 20h4V12zM12 2H14V30H12zM8 26H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6H8a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 018 26zM4 8H3.9985L4 24H8V8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeHorizontalRight.propTypes = iconPropTypes;
}
const DistributeVerticalBottom = /*#__PURE__*/React.forwardRef(function DistributeVerticalBottom(_ref19, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref19;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM24 26H8a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 26zm0-6.0012L8 20v4H24zM2 12H30V14H2zM20 10H12a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0120 10zm0-6.0012L12 4V8h8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeVerticalBottom.propTypes = iconPropTypes;
}
const DistributeVerticalCenter = /*#__PURE__*/React.forwardRef(function DistributeVerticalCenter(_ref20, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref20;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21H26V20a2.0023 2.0023 0 00-2-2H8a2.0023 2.0023 0 00-2 2v1H2v2H6v1a2.0023 2.0023 0 002 2H24a2.0023 2.0023 0 002-2V23h4zm-6 3H8V20l16-.001zM30 9H22V8a2.0023 2.0023 0 00-2-2H12a2.0023 2.0023 0 00-2 2V9H2v2h8v1a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V11h8zM20 12H12V8l8-.001z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeVerticalCenter.propTypes = iconPropTypes;
}
const DistributeVerticalTop = /*#__PURE__*/React.forwardRef(function DistributeVerticalTop(_ref21, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref21;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30H8a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 30zM8 24v4H24V24zM2 18H30V20H2zM20 14H12a2.0021 2.0021 0 01-2-2V8a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0120 14zM12 8v4h8V8zM2 2H30V4H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DistributeVerticalTop.propTypes = iconPropTypes;
}
const WatsonHealthDna = /*#__PURE__*/React.forwardRef(function WatsonHealthDna(_ref22, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref22;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthDna.propTypes = iconPropTypes;
}
const DnsServices = /*#__PURE__*/React.forwardRef(function DnsServices(_ref23, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref23;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H30V22H20zM20 24H26V26H20z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DnsServices.propTypes = iconPropTypes;
}
const Doc = /*#__PURE__*/React.forwardRef(function Doc(_ref24, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref24;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM18 23H14a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V21A2.0023 2.0023 0 0118 23zM14 11V21h4V11zM6 23H2V9H6a4.0045 4.0045 0 014 4v6A4.0045 4.0045 0 016 23zM4 21H6a2.002 2.002 0 002-2V13a2.002 2.002 0 00-2-2H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Doc.propTypes = iconPropTypes;
}
const Document = /*#__PURE__*/React.forwardRef(function Document(_ref25, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref25;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3 z M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22H22V24H10zM10 16H22V18H10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Document.propTypes = iconPropTypes;
}
const DocumentAdd = /*#__PURE__*/React.forwardRef(function DocumentAdd(_ref26, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref26;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentAdd.propTypes = iconPropTypes;
}
const DocumentAttachment = /*#__PURE__*/React.forwardRef(function DocumentAttachment(_ref27, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref27;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H11a2.0023,2.0023,0,0,1-2-2V22h2v6H26V6H17V4h9a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H24V12H17zM16 15H24V17H16zM15 20H24V22H15zM9 19a5.0055 5.0055 0 01-5-5V3H6V14a3 3 0 006 0V5a1 1 0 00-2 0V15H8V5a3 3 0 016 0v9A5.0055 5.0055 0 019 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentAttachment.propTypes = iconPropTypes;
}
const DocumentAudio = /*#__PURE__*/React.forwardRef(function DocumentAudio(_ref28, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref28;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29,31a.9987.9987,0,0,1-.6245-.2192L23.6494,27H20a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.6494l4.7261-3.7808A1,1,0,0,1,30,17V30a1,1,0,0,1-1,1Zm-8-6h3a1,1,0,0,1,.6245.2192L28,27.9194V19.0806l-3.3755,2.7A1,1,0,0,1,24,22H21Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentAudio.propTypes = iconPropTypes;
}
const DocumentBlank = /*#__PURE__*/React.forwardRef(function DocumentBlank(_ref29, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref29;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentBlank.propTypes = iconPropTypes;
}
const DocumentDownload = /*#__PURE__*/React.forwardRef(function DocumentDownload(_ref30, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref30;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2H18ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentDownload.propTypes = iconPropTypes;
}
const DocumentEpdf = /*#__PURE__*/React.forwardRef(function DocumentEpdf(_ref31, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref31;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26V22a2.0023,2.0023,0,0,0-2-2H22a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V28H22V26Zm-6-4h4v2H22Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentEpdf.propTypes = iconPropTypes;
}
const DocumentExport = /*#__PURE__*/React.forwardRef(function DocumentExport(_ref32, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref32;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21L26.17 21 23.59 23.59 25 25 30 20 25 15 23.59 16.41 26.17 19 13 19 13 21z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentExport.propTypes = iconPropTypes;
}
const DocumentHorizontal = /*#__PURE__*/React.forwardRef(function DocumentHorizontal(_ref33, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref33;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2.0023,2.0023,0,0,0,2,8V24a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,28,6ZM20,24H12V22a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm8,0H22V22a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H4V8H28Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18a4,4,0,1,0-4-4A4,4,0,0,0,16,18Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentHorizontal.propTypes = iconPropTypes;
}
const DocumentImport = /*#__PURE__*/React.forwardRef(function DocumentImport(_ref34, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref34;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L14.83 19 17.41 16.41 16 15 11 20 16 25 17.41 23.59 14.83 21 28 21 28 19z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V26H22v2H6V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L21.59,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentImport.propTypes = iconPropTypes;
}
const DocumentMultiple_01 = /*#__PURE__*/React.forwardRef(function DocumentMultiple_01(_ref35, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref35;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H4V26H2zM6 4H8V28H6zM14 22H26V24H14zM14 16H26V18H14z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7,9.3l-7-7C22.5,2.1,22.3,2,22,2H12c-1.1,0-2,0.9-2,2v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10 C30,9.7,29.9,9.5,29.7,9.3z M22,4.4l5.6,5.6H22V4.4z M28,28H12V4h8v6c0,1.1,0.9,2,2,2h6V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentMultiple_01.propTypes = iconPropTypes;
}
const DocumentMultiple_02 = /*#__PURE__*/React.forwardRef(function DocumentMultiple_02(_ref36, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref36;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18,31H6c-1.1,0-2-0.9-2-2V12h2v17h12V31z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M22,27H10c-1.1,0-2-0.9-2-2V8h2v17h12V27z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H24V18H16z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7C20.5,2.1,20.3,2,20,2h-6c-1.1,0-2,0.9-2,2v17c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V10 C28,9.7,27.9,9.5,27.7,9.3z M20,4.4l5.6,5.6H20V4.4z M26,21H14V4h4v6c0,1.1,0.9,2,2,2h6V21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentMultiple_02.propTypes = iconPropTypes;
}
const DocumentPdf = /*#__PURE__*/React.forwardRef(function DocumentPdf(_ref37, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref37;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18L30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18zM19 26H15V16h4a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0119 26zm-2-2h2a1.0011 1.0011 0 001-1V19a1.0011 1.0011 0 00-1-1H17zM11 16H6V26H8V23h3a2.0027 2.0027 0 002-2V18A2.0023 2.0023 0 0011 16zM8 21V18h3l.001 3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentPdf.propTypes = iconPropTypes;
}
const DocumentPreliminary = /*#__PURE__*/React.forwardRef(function DocumentPreliminary(_ref38, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref38;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM8 22H16V24H8zM8 16H18V18H8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentPreliminary.propTypes = iconPropTypes;
}
const DocumentProtected = /*#__PURE__*/React.forwardRef(function DocumentProtected(_ref39, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref39;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21V18a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-6-3a2,2,0,0,1,4,0v3H22ZM20,28V23h8v5Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentProtected.propTypes = iconPropTypes;
}
const DocumentSecurity = /*#__PURE__*/React.forwardRef(function DocumentSecurity(_ref40, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref40;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30l-2.1387-1.0127A5.0216,5.0216,0,0,1,18,24.4678V18H28v6.4678a5.0216,5.0216,0,0,1-2.8613,4.52ZM20,20v4.4678a3.012,3.012,0,0,0,1.7168,2.7109L23,27.7861l1.2832-.6074A3.012,3.012,0,0,0,26,24.4678V20Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentSecurity.propTypes = iconPropTypes;
}
const DocumentSigned = /*#__PURE__*/React.forwardRef(function DocumentSigned(_ref41, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref41;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "20",
    r: "1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2v9H22V4H6V28h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentSigned.propTypes = iconPropTypes;
}
const DocumentSketch = /*#__PURE__*/React.forwardRef(function DocumentSketch(_ref42, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref42;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentSketch.propTypes = iconPropTypes;
}
const DocumentSubtract = /*#__PURE__*/React.forwardRef(function DocumentSubtract(_ref43, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref43;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H30V26H20z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v8h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentSubtract.propTypes = iconPropTypes;
}
const DocumentTasks = /*#__PURE__*/React.forwardRef(function DocumentTasks(_ref44, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref44;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M15,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h7ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentTasks.propTypes = iconPropTypes;
}
const DocumentUnknown = /*#__PURE__*/React.forwardRef(function DocumentUnknown(_ref45, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref45;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "28.5",
    r: "1.5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10,25H8V21h2a2,2,0,0,0,0-4H8a2.0023,2.0023,0,0,0-2,2v.5H4V19a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7A.9085.9085,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4v8h2V4h8v6a2.0058,2.0058,0,0,0,2,2h6V28H14v2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,10V4.4L25.6,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentUnknown.propTypes = iconPropTypes;
}
const DocumentUnprotected = /*#__PURE__*/React.forwardRef(function DocumentUnprotected(_ref46, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref46;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21H22V18a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-8,7V23h8v5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentUnprotected.propTypes = iconPropTypes;
}
const DocumentVertical = /*#__PURE__*/React.forwardRef(function DocumentVertical(_ref47, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref47;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2H8A2.0023,2.0023,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM12,24V18a.9447.9447,0,0,1,1-1h6a.9447.9447,0,0,1,1,1v6H18v4H14V24Zm8,4V26a2.0058,2.0058,0,0,0,2-2V18a2.9463,2.9463,0,0,0-3-3H13a2.9463,2.9463,0,0,0-3,3v6a2.0058,2.0058,0,0,0,2,2v2H8V4H24V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentVertical.propTypes = iconPropTypes;
}
const DocumentVideo = /*#__PURE__*/React.forwardRef(function DocumentVideo(_ref48, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref48;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19l-4,3.2V20a2.0023,2.0023,0,0,0-2-2H16a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V23.8L30,27ZM16,26V20h8l.0015,6Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentVideo.propTypes = iconPropTypes;
}
const DocumentView = /*#__PURE__*/React.forwardRef(function DocumentView(_ref49, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref49;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentView.propTypes = iconPropTypes;
}
const DocumentWordProcessor = /*#__PURE__*/React.forwardRef(function DocumentWordProcessor(_ref50, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref50;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentWordProcessor.propTypes = iconPropTypes;
}
const DocumentWordProcessorReference = /*#__PURE__*/React.forwardRef(function DocumentWordProcessorReference(_ref51, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref51;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM25.707 9.293l-7-7A1 1 0 0018 2H8A2.002 2.002 0 006 4V16H8V4h8v6a2.002 2.002 0 002 2h6v4h2V10A1 1 0 0025.707 9.293zM18 10V4.4141L23.5859 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentWordProcessorReference.propTypes = iconPropTypes;
}
const DocumentSentiment = /*#__PURE__*/React.forwardRef(function DocumentSentiment(_ref52, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref52;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M18.303,16a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,25l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,16Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DocumentSentiment.propTypes = iconPropTypes;
}
const DogWalker = /*#__PURE__*/React.forwardRef(function DogWalker(_ref53, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref53;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V30H20zM4 23H6V30H4z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30H14V26a1.0011 1.0011 0 00-1-1H11v5H9V23h4a3.0033 3.0033 0 013 3zM7.5 22A3.5041 3.5041 0 014 18.5V17H2V15H6v3.5a1.5 1.5 0 003 0V15h4v2H11v1.5A3.5041 3.5041 0 017.5 22zM27 10H21.354a2.9861 2.9861 0 00-2.7856 1.8857l-1.4419 3.6055-3.6079 4.51 1.562 1.249 3.7-4.625 1.645-3.9961A.9949.9949 0 0121.354 12H27a1.0009 1.0009 0 011 1v7H25V30h2V22h1a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zM24 9a4 4 0 114-4A4.0045 4.0045 0 0124 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DogWalker.propTypes = iconPropTypes;
}
const DotMark = /*#__PURE__*/React.forwardRef(function DotMark(_ref54, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref54;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "8"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DotMark.propTypes = iconPropTypes;
}
const DoubleInteger = /*#__PURE__*/React.forwardRef(function DoubleInteger(_ref55, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref55;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8V6H13V2H11V6H8V2H6V6H2V8H6v3H2v2H6v4H8V13h3v4h2V13h4V11H13V8zm-6 3H8V8h3zM30 21V19H26V15H24v4H21V15H19v4H15v2h4v3H15v2h4v4h2V26h3v4h2V26h4V24H26V21zm-6 3H21V21h3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DoubleInteger.propTypes = iconPropTypes;
}
const DownToBottom = /*#__PURE__*/React.forwardRef(function DownToBottom(_ref56, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref56;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18L6 8 7.4 6.6 16 15.2 24.6 6.6 26 8zM4 22H28V24H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DownToBottom.propTypes = iconPropTypes;
}
const Download = /*#__PURE__*/React.forwardRef(function Download(_ref57, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref57;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
      d: "M13 7L12.3 6.3 8.5 10.1 8.5 1 7.5 1 7.5 10.1 3.7 6.3 3 7 8 12zM13 12v2H3v-2H2v2l0 0c0 .6.4 1 1 1h10c.6 0 1-.4 1-1l0 0v-2H13z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24v4H6V24H4v4H4a2 2 0 002 2H26a2 2 0 002-2h0V24zM26 14L24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Download.propTypes = iconPropTypes;
}
const WatsonHealthDownloadStudy = /*#__PURE__*/React.forwardRef(function WatsonHealthDownloadStudy(_ref58, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref58;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25zM19 14H23V16H19zM19 10H26V12H19zM9 18h6a3 3 0 013 3v2H16V21a1 1 0 00-1-1H9a1 1 0 00-1 1v2H6V21A3 3 0 019 18zM16 13a4 4 0 10-4 4A4 4 0 0016 13zm-2 0a2 2 0 11-2-2A2 2 0 0114 13z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthDownloadStudy.propTypes = iconPropTypes;
}
const Downstream = /*#__PURE__*/React.forwardRef(function Downstream(_ref59, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref59;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M5 24c-1.6567 0-3 1.3433-3 3s1.3433 3 3 3 3-1.3433 3-3-1.3433-3-3-3zm0 4c-.5522 0-1-.4478-1-1s.4478-1 1-1 1 .4478 1 1-.4478 1-1 1zM16 24c-1.6567 0-3 1.3433-3 3s1.3433 3 3 3 3-1.3433 3-3-1.3433-3-3-3zm0 4c-.5522 0-1-.4478-1-1s.4478-1 1-1 1 .4478 1 1-.4478 1-1 1zM27 24c-1.6567 0-3 1.3433-3 3s1.3433 3 3 3 3-1.3433 3-3-1.3433-3-3-3zm0 4c-.5522 0-1-.4478-1-1s.4478-1 1-1 1 .4478 1 1-.4478 1-1 1zM29.586 17.5859l-1.5859 1.5859v-3.1719c0-3.5542-2.6646-6.4917-6.0999-6.9355.0623-.3457.0999-.7007.0999-1.0645 0-3.3135-2.6863-6-6-6s-6 2.6865-6 6c0 .3638.0376.7188.0999 1.0645-3.4353.4438-6.0999 3.3813-6.0999 6.9355v3.1714l-1.5859-1.5854-1.4141 1.4141 4 4 4-4-1.4141-1.4141-1.5859 1.5859v-3.1719c0-2.6953 2.1479-4.8848 4.8203-4.9819.8799 1.5063 2.3945 2.5918 4.1797 2.8921v5.2617l-1.5859-1.5859-1.4141 1.4141 4 4 4-4-1.4141-1.4141-1.5859 1.5859v-5.2617c1.7852-.3003 3.2998-1.3857 4.1797-2.8921 2.6724.0972 4.8203 2.2866 4.8203 4.9819v3.1714l-1.5859-1.5854-1.4141 1.4141 4 4 4-4-1.4141-1.4141zm-13.5859-5.5859c-2.2056 0-4-1.7944-4-4s1.7944-4 4-4 4 1.7944 4 4-1.7944 4-4 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Downstream.propTypes = iconPropTypes;
}
const DragHorizontal = /*#__PURE__*/React.forwardRef(function DragHorizontal(_ref60, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref60;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L12 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 12 17 12 28 14 28 14 4 12 4zM25 11L23.59 12.41 26.17 15 20 15 20 4 18 4 18 28 20 28 20 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DragHorizontal.propTypes = iconPropTypes;
}
const DragVertical = /*#__PURE__*/React.forwardRef(function DragVertical(_ref61, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref61;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20zM11 7L12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DragVertical.propTypes = iconPropTypes;
}
const Draggable = /*#__PURE__*/React.forwardRef(function Draggable(_ref62, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref62;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H14V10H10zM18 6H22V10H18zM10 14H14V18H10zM18 14H22V18H18zM10 22H14V26H10zM18 22H22V26H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Draggable.propTypes = iconPropTypes;
}
const Draw = /*#__PURE__*/React.forwardRef(function Draw(_ref63, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref63;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M19.14,28a3.42,3.42,0,0,1-2.42-5.85L21.86,17a1.42,1.42,0,1,0-2-2L13,21.85a3.5,3.5,0,0,1-4.85,0,3.43,3.43,0,0,1,0-4.84l8.58-8.58a1.42,1.42,0,1,0-2-2L6.41,14.7,5,13.3,13.29,5a3.43,3.43,0,0,1,4.84,4.85L9.56,18.42a1.42,1.42,0,0,0,0,2,1.45,1.45,0,0,0,2,0l6.86-6.86a3.43,3.43,0,1,1,4.85,4.84l-5.15,5.15a1.42,1.42,0,0,0,2,2l4.44-4.43L26,22.56,21.56,27A3.38,3.38,0,0,1,19.14,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Draw.propTypes = iconPropTypes;
}
const DrillBack = /*#__PURE__*/React.forwardRef(function DrillBack(_ref64, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref64;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22L7.414 20.586 3.828 17 12 17 12 15 3.828 15 7.414 11.414 6 10 0 16 6 22z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a5.9815,5.9815,0,0,0-4.2427,1.7573L16,16l-4.2427,4.2427A6,6,0,1,0,16,10Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9581,13.9581,0,0,0,6.105,6.105L7.5188,7.5186a12,12,0,1,1,0,16.9628L6.105,25.895A13.9974,13.9974,0,1,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DrillBack.propTypes = iconPropTypes;
}
const DrillDown = /*#__PURE__*/React.forwardRef(function DrillDown(_ref65, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref65;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6L11.414 4.586 15 8.172 15 0 17 0 17 8.172 20.586 4.586 22 6 16 12 10 6z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M22,16a5.9815,5.9815,0,0,0-1.7573-4.2427L16,16l-4.2427-4.2427A6,6,0,1,0,22,16Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16a13.9581,13.9581,0,0,0-4.105-9.895L24.4814,7.5188a12,12,0,1,1-16.9628,0L6.105,6.105A13.9974,13.9974,0,1,0,30,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DrillDown.propTypes = iconPropTypes;
}
const DrillThrough = /*#__PURE__*/React.forwardRef(function DrillThrough(_ref66, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref66;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12L4 10 8.586 10 2 3.414 3.414 2 10 8.586 10 4 12 4 12 12 4 12zM16 10v6H10a6 6 0 106-6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DrillThrough.propTypes = iconPropTypes;
}
const Drink_01 = /*#__PURE__*/React.forwardRef(function Drink_01(_ref67, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref67;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M15,1h-5c-.5522,0-1,.4478-1,1v7.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5527,.4478,1,1,1h5v-2h-4V15c0-3.7536,3-4.2793,3-4.2793V3h3v7h2V2c0-.5522-.4478-1-1-1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Drink_01.propTypes = iconPropTypes;
}
const Drink_02 = /*#__PURE__*/React.forwardRef(function Drink_02(_ref68, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref68;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487V29c0,.5522,.4478,1,1,1h5v-2h-4V11.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Drink_02.propTypes = iconPropTypes;
}
const DriverAnalysis = /*#__PURE__*/React.forwardRef(function DriverAnalysis(_ref69, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref69;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27.91A6.0048,6.0048,0,0,0,22,10l-.022.001A9.9833,9.9833,0,0,0,4.0508,15H2v2H4.0508A9.9833,9.9833,0,0,0,21.978,21.999L22,22a6.0048,6.0048,0,0,0,5.91-5H30ZM14,8a7.9769,7.9769,0,0,1,5.7383,2.4463A6.0152,6.0152,0,0,0,16.0891,15H6.0693A8.0073,8.0073,0,0,1,14,8Zm0,16a8.0073,8.0073,0,0,1-7.9307-7h10.02a6.0152,6.0152,0,0,0,3.6492,4.5537A7.9769,7.9769,0,0,1,14,24Zm8-4a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DriverAnalysis.propTypes = iconPropTypes;
}
const Drone = /*#__PURE__*/React.forwardRef(function Drone(_ref70, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref70;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12a5 5 0 115-5H10a3 3 0 10-3 3zM25 12V10a3 3 0 10-3-3H20a5 5 0 115 5zM7 30A5 5 0 017 20v2a3 3 0 103 3h2A5.0055 5.0055 0 017 30zM25 30a5.0055 5.0055 0 01-5-5h2a3 3 0 103-3V20a5 5 0 010 10z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18.5859V13.4141L25.707,7.707a1,1,0,1,0-1.414-1.414l-4.4995,4.5a3.9729,3.9729,0,0,0-7.587,0L7.707,6.293a.9994.9994,0,0,0-1.414,0h0a.9994.9994,0,0,0,0,1.414L12,13.4141v5.1718L6.293,24.293a.9994.9994,0,0,0,0,1.414h0a.9994.9994,0,0,0,1.414,0l4.5-4.5a3.9729,3.9729,0,0,0,7.587,0l4.4995,4.5a1,1,0,0,0,1.414-1.414ZM18,20a2,2,0,0,1-4,0V12a2,2,0,0,1,4,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Drone.propTypes = iconPropTypes;
}
const DroneDelivery = /*#__PURE__*/React.forwardRef(function DroneDelivery(_ref71, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref71;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H12V22h8Zm-6-2h4V24H14Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M32 11L22 11 22 13 26 13 26 16 6 16 6 13 10 13 10 11 0 11 0 13 4 13 4 18 9.132 18 6 22.697 6 27 8 27 8 23.303 11.535 18 20.465 18 24 23.303 24 27 26 27 26 22.697 22.868 18 28 18 28 13 32 13 32 11zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DroneDelivery.propTypes = iconPropTypes;
}
const DroneFront = /*#__PURE__*/React.forwardRef(function DroneFront(_ref72, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref72;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DroneFront.propTypes = iconPropTypes;
}
const DroneVideo = /*#__PURE__*/React.forwardRef(function DroneVideo(_ref73, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref73;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "21",
    r: "1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DroneVideo.propTypes = iconPropTypes;
}
const DropPhoto = /*#__PURE__*/React.forwardRef(function DropPhoto(_ref74, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref74;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29H11a2 2 0 01-2-2V18a2 2 0 012-2h3.2793l.5441-1.6324A2 2 0 0116.7208 13h4.5584a2 2 0 011.8974 1.3676L23.7207 16H27a2 2 0 012 2v9A2 2 0 0127 29zM11 27H27V18H22.2792l-1-3H16.7207l-1 3H11zM27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DropPhoto.propTypes = iconPropTypes;
}
const DropPhotoFilled = /*#__PURE__*/React.forwardRef(function DropPhotoFilled(_ref75, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref75;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "22",
    r: "2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M27,16H23.7207l-.5439-1.6328A1.9983,1.9983,0,0,0,21.2793,13H16.7207a1.9981,1.9981,0,0,0-1.8975,1.3677L14.2793,16H11a2.0023,2.0023,0,0,0-2,2v9a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,27,16ZM19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z",
    "data-icon-path": "inner-path"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DropPhotoFilled.propTypes = iconPropTypes;
}
const Drought = /*#__PURE__*/React.forwardRef(function Drought(_ref76, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref76;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M27,18h3V15a4.0045,4.0045,0,0,0-4-4H25V9.5A3.5042,3.5042,0,0,0,21.5,6a3.4556,3.4556,0,0,0-1.5.3511V5.41a3.41,3.41,0,0,0-6.5449-1.3433L11.3408,9H9a5.0059,5.0059,0,0,0-5,5v4H8a5.0059,5.0059,0,0,0,5-5V10.2051l2.293-5.35A1.41,1.41,0,0,1,18,5.41V22H14.6123L11,25.2939,7.3877,22H2v2H6.6123L11,28l4.3877-4H30V22H20V9.5a1.5,1.5,0,0,1,3,0V14A4.0045,4.0045,0,0,0,27,18Zm-2-5h1a2.0023,2.0023,0,0,1,2,2v1H27a2.0023,2.0023,0,0,1-2-2ZM11,13a3.0033,3.0033,0,0,1-3,3H6V14a3.0033,3.0033,0,0,1,3-3h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Drought.propTypes = iconPropTypes;
}
const Dvr = /*#__PURE__*/React.forwardRef(function Dvr(_ref77, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref77;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM6 23H2V9H6a4 4 0 014 4v6A4 4 0 016 23zM4 21H6a2 2 0 002-2V13a2 2 0 00-2-2H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Dvr.propTypes = iconPropTypes;
}
const Earth = /*#__PURE__*/React.forwardRef(function Earth(_ref78, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref78;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Earth.propTypes = iconPropTypes;
}
const EarthAmericas = /*#__PURE__*/React.forwardRef(function EarthAmericas(_ref79, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref79;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16a14.0313,14.0313,0,1,0-7.14,12.1914l.1165.0254.0249-.1113A13.9983,13.9983,0,0,0,30,16ZM4,16a11.9369,11.9369,0,0,1,.395-3H8.6382L13.63,17.16l-1.9092,2.5459a2.0088,2.0088,0,0,0,.1855,2.6142L14,24.4141v3.4052A12.0093,12.0093,0,0,1,4,16Zm9.32,4.9062L16.37,16.84,9.3618,11H5.1055A11.9619,11.9619,0,0,1,22.8838,6.1865L22.2793,8H16.5859L13.543,11.043l9.3535,8.3134L21.248,26.7749A11.9034,11.9034,0,0,1,16,28V23.5859Zm10.315,4.3443,1.2133-5.46a2.0007,2.0007,0,0,0-.6235-1.9277L16.457,10.957,17.4141,10h4.8652a1.9981,1.9981,0,0,0,1.8975-1.3677l.3532-1.06a11.9777,11.9777,0,0,1-.8947,17.6782Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthAmericas.propTypes = iconPropTypes;
}
const EarthAmericasFilled = /*#__PURE__*/React.forwardRef(function EarthAmericasFilled(_ref80, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref80;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16a11.915,11.915,0,0,1,.7-4H10l5,4-2.8,3.6929A1,1,0,0,0,12.293,21L15,24v3.9492A12.01,12.01,0,0,1,4,16ZM21.4348,26.6846l2.5457-7.6992A1,1,0,0,0,23.614,18L15,11l2-2h5.2793a1,1,0,0,0,.9487-.6836L23.7234,6.83a11.9742,11.9742,0,0,1-2.2886,19.855Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthAmericasFilled.propTypes = iconPropTypes;
}
const EarthEuropeAfrica = /*#__PURE__*/React.forwardRef(function EarthEuropeAfrica(_ref81, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref81;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.96,11.96,0,0,1,8,7.0811V9a2,2,0,0,0,2,2h3.3818a2,2,0,0,0,1.7893-1.106L15.6182,9H18v4H13.2354a2,2,0,0,0-.8936.2109L9.1055,14.8291A2,2,0,0,0,8,16.6177v3.7055A2,2,0,0,0,9.2573,22.18l3.8487,1.54.6779,4.0664A12.0135,12.0135,0,0,1,4,16ZM15.8457,27.9922,14.894,22.28,10,20.3232v-3.705L13.2358,15H20V7H14.3818l-1,2H10V5.6235A11.9578,11.9578,0,0,1,27.3,12H22v4l.9224,3.8135L21,22.6973v4.1972A11.9083,11.9083,0,0,1,16,28C15.948,28,15.8977,27.9927,15.8457,27.9922ZM23,25.7266V23.3027l1.5859-2.3789a2.0027,2.0027,0,0,0,.2769-1.5957L24,15.877V14h3.8193A11.8409,11.8409,0,0,1,23,25.7266Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthEuropeAfrica.propTypes = iconPropTypes;
}
const EarthEuropeAfricaFilled = /*#__PURE__*/React.forwardRef(function EarthEuropeAfricaFilled(_ref82, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref82;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.9814,11.9814,0,0,1,9,6.2734V9a1,1,0,0,0,1,1h3.3821a1,1,0,0,0,.8943-.5527L15,8h4v6H13.2361a1.0006,1.0006,0,0,0-.4473.1055L9.5527,15.7236A1,1,0,0,0,9,16.6182v3.7046a1,1,0,0,0,.6287.9287L14,23l.8235,4.94A12.0152,12.0152,0,0,1,4,16ZM22,26.376V23l1.7546-2.6318a1.0012,1.0012,0,0,0,.1382-.7974L23,16V13h4.605A11.901,11.901,0,0,1,22,26.376Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthEuropeAfricaFilled.propTypes = iconPropTypes;
}
const EarthFilled = /*#__PURE__*/React.forwardRef(function EarthFilled(_ref83, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref83;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.02,16.394l1.3384.4458L7,19.3027v1.2831a1,1,0,0,0,.2929.7071L10,24v2.3765A11.9941,11.9941,0,0,1,4.02,16.394ZM16,28a11.9682,11.9682,0,0,1-2.5718-.2847L14,26l1.8046-4.5116a1,1,0,0,0-.0964-.9261l-1.4113-2.117A1,1,0,0,0,13.4648,18h-4.93L7.2866,16.1274,9.4141,14H11v2h2V13.2656l3.8682-6.7695-1.7364-.9922L14.2769,7H11.5352l-1.086-1.6289A11.861,11.861,0,0,1,20,4.7V8a1,1,0,0,0,1,1h1.4648a1,1,0,0,0,.8321-.4453l.8769-1.3154A12.0331,12.0331,0,0,1,26.8945,11H22.82a1,1,0,0,0-.9806.8039l-.7221,4.4708a1,1,0,0,0,.54,1.0539L25,19l.6851,4.0557A11.9793,11.9793,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthFilled.propTypes = iconPropTypes;
}
const EarthSoutheastAsia = /*#__PURE__*/React.forwardRef(function EarthSoutheastAsia(_ref84, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref84;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H17V26H14zM17 22H19V24H17zM17 18H19V20H17z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm-.603,2.03,2.5073,5.0156L16.3228,13H10.271l-1.41,4.3872,2.8521,2.8521L10.7056,21.751,6.2856,19H4.395A11.9363,11.9363,0,0,1,15.397,4.03ZM5.1055,21h.6089l3.9345,2.4487A1.9912,1.9912,0,0,0,12.37,22.86l1.0078-1.5118a2.005,2.005,0,0,0-.25-2.5234l-1.9887-1.9888L11.729,15h4.5938A1.9906,1.9906,0,0,0,18.18,13.7427L19.7612,9.79a2.0019,2.0019,0,0,0-.0674-1.6382L17.6843,4.1323A11.9592,11.9592,0,0,1,26.8945,21H23a2.0023,2.0023,0,0,0-2,2v3.8945A11.9477,11.9477,0,0,1,5.1055,21ZM23,25.7266V23h2.7268A12.0762,12.0762,0,0,1,23,25.7266Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthSoutheastAsia.propTypes = iconPropTypes;
}
const EarthSoutheastAsiaFilled = /*#__PURE__*/React.forwardRef(function EarthSoutheastAsiaFilled(_ref85, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref85;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22H19V24H17zM17 18H19V20H17zM14 24H17V26H14z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.7,20H6l4.1772,2.6a1,1,0,0,0,1.36-.2939l1.0078-1.5118a1,1,0,0,0-.125-1.2617L10,17.1118,11,14h5.323a1,1,0,0,0,.9285-.6284L18.8333,9.417a1,1,0,0,0-.034-.8189L16.5129,4.0259A11.9652,11.9652,0,0,1,26.3762,22H23a1,1,0,0,0-1,1v3.3765A11.9578,11.9578,0,0,1,4.7,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthSoutheastAsiaFilled.propTypes = iconPropTypes;
}
const Earthquake = /*#__PURE__*/React.forwardRef(function Earthquake(_ref86, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref86;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM6,12.0615,15,5.05v7.3638l3.458,3.458-6.7344,4.8105L14.3818,26H6ZM26,26H16.6182l-2.3418-4.6826,7.2656-5.1895L17,11.5859V5.0518l9,7.02Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Earthquake.propTypes = iconPropTypes;
}
const EdgeCluster = /*#__PURE__*/React.forwardRef(function EdgeCluster(_ref87, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref87;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7a3 3 0 113-3A3.0033 3.0033 0 0116 7zm0-4a1 1 0 101 1A1.001 1.001 0 0016 3zM11 30a3 3 0 113-3A3.0033 3.0033 0 0111 30zm0-4a1 1 0 101 1A1.001 1.001 0 0011 26zM7 11a3 3 0 113-3A3.0033 3.0033 0 017 11zM7 7A1 1 0 108 8 1.001 1.001 0 007 7zM21 30a3 3 0 113-3A3.0033 3.0033 0 0121 30zm0-4a1 1 0 101 1A1.001 1.001 0 0021 26zM25 11a3 3 0 113-3A3.0033 3.0033 0 0125 11zm0-4a1 1 0 101 1A1.001 1.001 0 0025 7zM4 21a3 3 0 113-3A3.0033 3.0033 0 014 21zm0-4a1 1 0 101 1A1.001 1.001 0 004 17zM28 21a3 3 0 113-3A3.0033 3.0033 0 0128 21zm0-4a1 1 0 101 1A1.001 1.001 0 0028 17zM16 22a6 6 0 116-6A6.0069 6.0069 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdgeCluster.propTypes = iconPropTypes;
}
const EdgeDevice = /*#__PURE__*/React.forwardRef(function EdgeDevice(_ref88, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref88;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H23V23H9zM11 14a2 2 0 102 2A1.9806 1.9806 0 0011 14zM21 14a2 2 0 102 2A1.9806 1.9806 0 0021 14z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H18.4141l2.0722-2.0723A2.04,2.04,0,0,0,21,6a2,2,0,1,0-2-2,2.0412,2.0412,0,0,0,.0723.5137L15.5859,8H4a2.0025,2.0025,0,0,0-2,2V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM4,26V10H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdgeDevice.propTypes = iconPropTypes;
}
const WatsonHealthEdgeEnhancement = /*#__PURE__*/React.forwardRef(function WatsonHealthEdgeEnhancement(_ref89, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref89;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM16 26A10 10 0 0016 6h0z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16A14,14,0,0,0,16,2V4a11.9933,11.9933,0,0,1,4.0493,23.2847c-.1682.06-.334.1294-.5044.1821-.2512.0771-.51.1362-.7683.1973-.1262.03-.25.0693-.3772.0952-.2908.0591-.5884.0976-.8862.1352-.1.0122-.1983.0342-.2988.044A12.0015,12.0015,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30q.7134,0,1.415-.0713c.135-.0137.2654-.042.3995-.06.3286-.0424.6574-.0839.9814-.1494.18-.0366.3533-.0908.5308-.1338.2685-.0659.5383-.125.8027-.2065.2463-.0762.4831-.1724.7234-.2612.18-.0664.3635-.1211.5412-.1953l-.0009-.0025A14.0015,14.0015,0,0,0,30,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthEdgeEnhancement.propTypes = iconPropTypes;
}
const WatsonHealthEdgeEnhancement_01 = /*#__PURE__*/React.forwardRef(function WatsonHealthEdgeEnhancement_01(_ref90, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref90;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M26 28L26 20 24 20 24 21 22 21 22 23 24 23 24 28 22 28 22 30 28 30 28 28 26 28zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthEdgeEnhancement_01.propTypes = iconPropTypes;
}
const WatsonHealthEdgeEnhancement_02 = /*#__PURE__*/React.forwardRef(function WatsonHealthEdgeEnhancement_02(_ref91, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref91;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H22V26a2.002 2.002 0 012-2h2V22H22V20h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H24v2h4zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthEdgeEnhancement_02.propTypes = iconPropTypes;
}
const WatsonHealthEdgeEnhancement_03 = /*#__PURE__*/React.forwardRef(function WatsonHealthEdgeEnhancement_03(_ref92, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref92;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0026 20zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthEdgeEnhancement_03.propTypes = iconPropTypes;
}
const EdgeNode = /*#__PURE__*/React.forwardRef(function EdgeNode(_ref93, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref93;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H26V10H22z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "21",
    r: "1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "17",
    r: "1"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M22,17V15H20V14a2.0023,2.0023,0,0,0-2-2H17V10H15v2H13V10H11v2H10a2.0023,2.0023,0,0,0-2,2v1H6v2H8v2H6v2H8v1a2.0023,2.0023,0,0,0,2,2h1v2h2V24h2v2h2V24h1a2.0023,2.0023,0,0,0,2-2V21h2V19H20V17Zm-4,5H10V14h8Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdgeNode.propTypes = iconPropTypes;
}
const EdgeNodeAlt = /*#__PURE__*/React.forwardRef(function EdgeNodeAlt(_ref94, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref94;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023a2.0429,2.0429,0,0,0,0-.8174l4.0039-2.4023A2.9909,2.9909,0,1,0,24,15a2.9345,2.9345,0,0,0,.0415.4092l-4.0039,2.4023a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,24,25a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,27,14Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,18,21Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,26Z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "8",
    r: "1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "16",
    r: "1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "24",
    r: "1"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13V5a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,5V27a2.0023,2.0023,0,0,0,2,2H20V27H4V21h8V19H4V13ZM4,5H20v6H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdgeNodeAlt.propTypes = iconPropTypes;
}
const EdgeService = /*#__PURE__*/React.forwardRef(function EdgeService(_ref95, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref95;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H9V21H7zM11 11H13V21H11zM15 11H17V21H15zM19 11H21V21H19zM23 11H25V21H23z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H28a2.0023,2.0023,0,0,1,2,2V24A2.0023,2.0023,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdgeService.propTypes = iconPropTypes;
}
const Edit = /*#__PURE__*/React.forwardRef(function Edit(_ref96, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref96;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Edit.propTypes = iconPropTypes;
}
const EditOff = /*#__PURE__*/React.forwardRef(function EditOff(_ref97, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref97;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.6L3.4 2 2 3.4l10.1 10.1L4 21.6V28h6.4l8.1-8.1L28.6 30 30 28.6zM9.6 26H6v-3.6l7.5-7.5 3.6 3.6L9.6 26zM29.4 6.2L29.4 6.2l-3.6-3.6c-.8-.8-2-.8-2.8 0l0 0 0 0-8 8 1.4 1.4L20 8.4l3.6 3.6L20 15.6l1.4 1.4 8-8C30.2 8.2 30.2 7 29.4 6.2L29.4 6.2zM25 10.6L21.4 7l3-3L28 7.6 25 10.6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EditOff.propTypes = iconPropTypes;
}
const EdtLoop = /*#__PURE__*/React.forwardRef(function EdtLoop(_ref98, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref98;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625,22.5875a6.1287,6.1287,0,0,1-4.5-1.9l-3.1-3.2-3.1,3.2a6.4582,6.4582,0,0,1-9.1,0,7.028,7.028,0,0,1-1.8-4.7,6.6547,6.6547,0,0,1,1.9-4.7,6.3375,6.3375,0,0,1,9,0l3.1,3.2,3.1-3.2a6.3375,6.3375,0,0,1,9,0,6.8282,6.8282,0,0,1,0,9.4A6.5418,6.5418,0,0,1,23.625,22.5875Zm-6.2-6.6,3.1,3.3a4.4061,4.4061,0,0,0,6.2,0,4.9077,4.9077,0,0,0,0-6.6,4.4061,4.4061,0,0,0-6.2,0Zm-9-4.6a4.1582,4.1582,0,0,0-3.1,1.3,4.8385,4.8385,0,0,0,0,6.6,4.4061,4.4061,0,0,0,6.2,0l3.1-3.3-3.1-3.3A4.7706,4.7706,0,0,0,8.425,11.3875Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdtLoop.propTypes = iconPropTypes;
}
const Education = /*#__PURE__*/React.forwardRef(function Education(_ref99, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref99;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30H24V27a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v3H6V27a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM5 6A1 1 0 004 7v9H6V7A1 1 0 005 6z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2V4H9v7a7,7,0,0,0,14,0V4h5V2Zm7,2H21V7H11Zm5,12a5,5,0,0,1-5-5V9H21v2A5,5,0,0,1,16,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Education.propTypes = iconPropTypes;
}
const Email = /*#__PURE__*/React.forwardRef(function Email(_ref100, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref100;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Email.propTypes = iconPropTypes;
}
const EmailNew = /*#__PURE__*/React.forwardRef(function EmailNew(_ref101, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref101;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24H4L3.9966,8.9062l11.4341,7.9161a1.0008,1.0008,0,0,0,1.1386,0L28,8.9087,28,18h2V8a2.0027,2.0027,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,8V24a2.0027,2.0027,0,0,0,2,2H19ZM25.7986,8,16,14.7837,6.2014,8Z"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "24",
    r: "4"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EmailNew.propTypes = iconPropTypes;
}
const Encryption = /*#__PURE__*/React.forwardRef(function Encryption(_ref102, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref102;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21.2783V19a4 4 0 00-8 0v2.2783A1.9935 1.9935 0 0020 23v5a2.0025 2.0025 0 002 2h6a2.0025 2.0025 0 002-2V23A1.9935 1.9935 0 0029 21.2783zM25 17a2.0025 2.0025 0 012 2v2H23V19A2.0025 2.0025 0 0125 17zM22 28V23h6v5zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM2 8H4V16H2zM2 18H4V26H2zM14 18H16V26H14zM6 8H8V16H6zM18 8H20V14H18zM10 26H8a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0110 26zM8 20v4h2V20zM14 16H12a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0114 16zm-2-6v4h2V10zM10 6H8A2.0023 2.0023 0 016 4V2H8V4h2V2h2V4A2.0023 2.0023 0 0110 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Encryption.propTypes = iconPropTypes;
}
const EnergyRenewable = /*#__PURE__*/React.forwardRef(function EnergyRenewable(_ref103, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref103;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14H28V10H26v4H24V10H22v4H21a1,1,0,0,0-1,1v4a5.0079,5.0079,0,0,0,4,4.8989V27a1.0008,1.0008,0,0,1-1,1H5a1,1,0,0,1,0-2h5a3,3,0,0,0,0-6H5a1,1,0,0,1,0-2h5a3.0033,3.0033,0,0,0,3-3V11h1a4.0045,4.0045,0,0,0,4-4V4H15a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,7,2H4V5a6.0066,6.0066,0,0,0,6,6h1v4a1.0008,1.0008,0,0,1-1,1H5a3,3,0,0,0,0,6h5a1,1,0,0,1,0,2H5a3,3,0,0,0,0,6H23a3.0033,3.0033,0,0,0,3-3V23.8989A5.0079,5.0079,0,0,0,30,19V15A1,1,0,0,0,29,14ZM13,8a2.002,2.002,0,0,1,2-2h1V7a2.002,2.002,0,0,1-2,2H13ZM10,9A4.0045,4.0045,0,0,1,6,5V4H7a4.0045,4.0045,0,0,1,4,4V9ZM28,19a3,3,0,0,1-6,0V16h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EnergyRenewable.propTypes = iconPropTypes;
}
const Enterprise = /*#__PURE__*/React.forwardRef(function Enterprise(_ref104, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref104;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Enterprise.propTypes = iconPropTypes;
}
const EqualApproximately = /*#__PURE__*/React.forwardRef(function EqualApproximately(_ref105, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref105;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15c-1.7771 0-3.2314-.8726-4.5144-1.6425-1.1636-.6981-2.2627-1.3575-3.4856-1.3575-1.3977 0-2.449.8629-3.2927 1.707l-1.4146-1.4141c1.0674-1.0675 2.5669-2.293 4.7073-2.293 1.7771 0 3.2314.8726 4.5144 1.6425 1.1636.6981 2.2627 1.3575 3.4856 1.3575 1.3975 0 2.4487-.8629 3.293-1.7072l1.4141 1.4143c-1.0674 1.0675-2.5671 2.2928-4.707 2.2928zM20 22c-1.7771 0-3.2314-.8726-4.5144-1.6425-1.1636-.6981-2.2627-1.3575-3.4856-1.3575-1.3977 0-2.449.8629-3.2927 1.707l-1.4146-1.4141c1.0674-1.0675 2.5669-2.293 4.7073-2.293 1.7771 0 3.2314.8726 4.5144 1.6425 1.1636.6981 2.2627 1.3575 3.4856 1.3575 1.3975 0 2.4487-.8629 3.293-1.7072l1.4141 1.4143c-1.0674 1.0675-2.5671 2.2928-4.707 2.2928z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m16,30c-7.7197,0-14-6.2804-14-14S8.2802,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EqualApproximately.propTypes = iconPropTypes;
}
const Equalizer = /*#__PURE__*/React.forwardRef(function Equalizer(_ref106, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref106;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H10V30H2zM2 24H10V26H2zM12 28H20V30H12zM12 24H20V26H12zM2 20H10V22H2zM12 20H20V22H12zM2 16H10V18H2zM12 16H20V18H12zM12 12H20V14H12zM12 8H20V10H12zM12 4H20V6H12zM22 28H30V30H22zM22 24H30V26H22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Equalizer.propTypes = iconPropTypes;
}
const Erase = /*#__PURE__*/React.forwardRef(function Erase(_ref107, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref107;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M7 27H30V29H7zM27.38 10.51L19.45 2.59a2 2 0 00-2.83 0l-14 14a2 2 0 000 2.83L7.13 24h9.59L27.38 13.34A2 2 0 0027.38 10.51zM15.89 22H8L4 18l6.31-6.31 7.93 7.92zm3.76-3.76l-7.92-7.93L18 4 26 11.93z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Erase.propTypes = iconPropTypes;
}
const WatsonHealthErase_3D = /*#__PURE__*/React.forwardRef(function WatsonHealthErase_3D(_ref108, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref108;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4148 16.5132L22.488 8.5859a2.0014 2.0014 0 00-2.8291 0L5.6208 22.624a2.0024 2.0024 0 000 2.8291L10.1663 30h9.5908L30.4148 19.3413A2.001 2.001 0 0030.4148 16.5132zM18.929 28H10.9949l-3.96-3.9619 6.3123-6.3118 7.9276 7.9276zm3.76-3.76l-7.9276-7.9276L21.074 10l7.9267 7.9272zM11 12H8V2h3a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0111 12zm-1-2h1a1.0009 1.0009 0 001-1V5a1.0009 1.0009 0 00-1-1H10zM4 2H0V4H4V6H1V8H4v2H0v2H4a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 004 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthErase_3D.propTypes = iconPropTypes;
}
const Error = /*#__PURE__*/React.forwardRef(function Error(_ref109, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref109;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Error.propTypes = iconPropTypes;
}
const ErrorFilled = /*#__PURE__*/React.forwardRef(function ErrorFilled(_ref110, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref110;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z"
    })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
      d: "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z"
    })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
      d: "M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
      d: "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z"
    })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.9 7.2H17.1V24.799H14.9z",
    "data-icon-path": "inner-path",
    transform: "rotate(-45 16 16)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.914,13.914,0,0,0,2,16,13.914,13.914,0,0,0,16,30,13.914,13.914,0,0,0,30,16,13.914,13.914,0,0,0,16,2Zm5.4449,21L9,10.5557,10.5557,9,23,21.4448Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ErrorFilled.propTypes = iconPropTypes;
}
const ErrorOutline = /*#__PURE__*/React.forwardRef(function ErrorOutline(_ref111, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref111;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
    })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
      d: "M7.4 3.6H8.5V12.4H7.4z",
      transform: "rotate(-45.001 8 8)"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 7.2H17.1V24.799H14.9z",
    transform: "rotate(-45 16 16)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9138,13.9138,0,0,0,2,16,13.9138,13.9138,0,0,0,16,30,13.9138,13.9138,0,0,0,30,16,13.9138,13.9138,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12.0353,12.0353,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ErrorOutline.propTypes = iconPropTypes;
}
const Event = /*#__PURE__*/React.forwardRef(function Event(_ref112, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref112;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L23.549 19.938 29 20.729 25 24.573 26 30 21 27.438 16 30 17 24.573 13 20.729 18.6 19.938 21 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Event.propTypes = iconPropTypes;
}
const EventChange = /*#__PURE__*/React.forwardRef(function EventChange(_ref113, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref113;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15H19V22H17z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "25",
    r: "1.25"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30H7c-.3499 0-.6743-.1829-.8555-.4823s-.1926-.6718-.0303-.9817L17.1143 7.536c.1726-.3296.5292-.536.8857-.536s.7131.2064.8857.536l11 21c.1624.3099.1509.6823-.0303.9817s-.5056.4823-.8555.4823zm-20.3474-2h18.6948l-9.3474-17.8448-9.3474 17.8448zM7 23H3c-.3467 0-.6685-.1794-.8506-.4742-.1824-.2948-.1987-.663-.0439-.973l2.5-5 1.7891.8945-1.7766 3.5527h2.3821v2z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M4.955 11.5H10.545V13.5H4.955z",
    transform: "rotate(-63.435 7.75 12.5)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "m10.8945,8.4473l-1.7891-.8945,2.5-5c.1694-.3387.532-.5527.8945-.5527s.7251.214.8945.5527l2,4-1.7891.8945-1.1055-2.2112-1.6055,3.2112Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EventChange.propTypes = iconPropTypes;
}
const EventIncident = /*#__PURE__*/React.forwardRef(function EventIncident(_ref114, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref114;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0176 26.7217L22.016 28.4541 24.9938 26.7322 24.9938 30 26.9907 30 26.9907 26.7316 30.0016 28.4727 31 26.7402 27.9898 24.9996 30.9902 23.2646 29.9918 21.5322 26.9907 23.2677 26.9907 20 24.9938 20 24.9938 23.2672 21.9984 21.5352 21 23.2676 23.9954 24.9996 21.0176 26.7217zM16 23c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5h0zM15 12H17V21H15z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m18,30H3c-.3494,0-.6736-.1824-.8547-.4811-.1814-.2986-.1936-.6703-.0325-.9802L15.1128,3.5387c.1721-.3311.5297-.5387.8872-.5387s.7151.2076.8872.5387l6.76,13-1.7744.9226-5.8728-11.2938L4.6472,28h13.3528v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EventIncident.propTypes = iconPropTypes;
}
const EventSchedule = /*#__PURE__*/React.forwardRef(function EventSchedule(_ref115, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref115;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30a8,8,0,1,1,8-8A8,8,0,0,1,21,30Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,21,16Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M22.59 25L20 22.41 20 18 22 18 22 21.59 24 23.59 22.59 25z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EventSchedule.propTypes = iconPropTypes;
}
const EventWarning = /*#__PURE__*/React.forwardRef(function EventWarning(_ref116, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref116;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3803 28h-6.7625l3.3822-6.7642 3.3803 6.7642zm-3.3803-10c-.3915 0-.7305.2251-.8947.5527l-5 10c-.0674.1348-.1053.2866-.1053.4473 0 .5522.4477 1 1 1h10c.5523 0 1-.4478 1-1 0-.1382-.028-.2695-.0786-.3892l-5.0269-10.0581c-.1641-.3276-.5031-.5527-.8946-.5527h0zM16 23c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5h0zM15 12H17V21H15z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "m15,30H3c-.3494,0-.6736-.1824-.8547-.4811-.1814-.2986-.1936-.6703-.0325-.9802L15.1128,3.5387c.1721-.3311.5297-.5387.8872-.5387s.7151.2076.8872.5387l6,11.5385-1.7744.9226-5.1128-9.8322L4.6472,28h10.3528v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EventWarning.propTypes = iconPropTypes;
}
const Events = /*#__PURE__*/React.forwardRef(function Events(_ref117, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref117;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14H24v2h2a3.0033 3.0033 0 013 3v4h2V19A5.0058 5.0058 0 0026 14zM24 4a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 2zM23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11zM8 14H6a5.0059 5.0059 0 00-5 5v4H3V19a3.0033 3.0033 0 013-3H8zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Events.propTypes = iconPropTypes;
}
const EventsAlt = /*#__PURE__*/React.forwardRef(function EventsAlt(_ref118, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref118;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M18 31h2V29a1.0006 1.0006 0 011-1h6a1.0006 1.0006 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 25a4 4 0 114-4A4.0039 4.0039 0 0124 25zm0-6a2 2 0 102 2A2.0027 2.0027 0 0024 19zM2 31H4V29a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 25a4 4 0 114-4A4.0042 4.0042 0 018 25zm0-6a2 2 0 102 2A2.0023 2.0023 0 008 19zM18 16h2V14a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 10a4 4 0 114-4A4.0042 4.0042 0 0124 10zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 4zM2 16H4V14a1.0013 1.0013 0 011-1h6a1.0013 1.0013 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EventsAlt.propTypes = iconPropTypes;
}
const ExamMode = /*#__PURE__*/React.forwardRef(function ExamMode(_ref119, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref119;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23v3H7V16.83l3.59 3.58L12 19 6 13 0 19l1.41 1.41L5 16.83V26a2 2 0 002 2H25a2 2 0 002-2V23zM27 7v9.17l3.59-3.58L32 14l-6 6-6-6 1.41-1.41L25 16.17V7H13V5H25A2 2 0 0127 7zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ExamMode.propTypes = iconPropTypes;
}
const ExecutableProgram = /*#__PURE__*/React.forwardRef(function ExecutableProgram(_ref120, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref120;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25 21L32 26 25 31 25 21z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "8",
    r: "1"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4V12H28v7h2V6c0-1.1025-.8972-2-2-2H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H21v-2ZM4,6H28v4H4V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ExecutableProgram.propTypes = iconPropTypes;
}
const Exit = /*#__PURE__*/React.forwardRef(function Exit(_ref121, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref121;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M26 4H28V28H26zM11.414 20.586L7.828 17 22 17 22 15 7.828 15 11.414 11.414 10 10 4 16 10 22 11.414 20.586z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Exit.propTypes = iconPropTypes;
}
const ExpandAll = /*#__PURE__*/React.forwardRef(function ExpandAll(_ref122, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref122;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10H26a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2V5H6V2H4V25a2.0025,2.0025,0,0,0,2,2h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V24a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V17h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V14a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V7h4V8A2.0025,2.0025,0,0,0,12,10Zm0-6H26l.0012,4H12Zm0,20H26l.0012,4H12Zm0-10H26l.0012,4H12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ExpandAll.propTypes = iconPropTypes;
}
const ExpandCategories = /*#__PURE__*/React.forwardRef(function ExpandCategories(_ref123, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref123;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26H26V28H20zM20 18H28V20H20zM20 10H30V12H20zM15 4H17V28H15zM10.586 3.959L7 7.249 3.412 3.958 2 5.373 7 10 12 5.373 10.586 3.959z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ExpandCategories.propTypes = iconPropTypes;
}
const Explore = /*#__PURE__*/React.forwardRef(function Explore(_ref124, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref124;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M22.707,9.2931a.9992.9992,0,0,0-1.0234-.2417l-9,3a1.001,1.001,0,0,0-.6323.6323l-3,9a1,1,0,0,0,1.2651,1.2651l9-3a1.0013,1.0013,0,0,0,.6323-.6324l3-9A1,1,0,0,0,22.707,9.2931ZM11.5811,20.419l2.2094-6.6284L18.21,18.21Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Explore.propTypes = iconPropTypes;
}
const Export = /*#__PURE__*/React.forwardRef(function Export(_ref125, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref125;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
      d: "M13 12v2H3v-2H2v2l0 0c0 .6.4 1 1 1h10c.6 0 1-.4 1-1l0 0v-2H13zM3 6L3.7 6.7 7.5 2.9 7.5 12 8.5 12 8.5 2.9 12.3 6.7 13 6 8 1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24v4H6V24H4v4l.0076-.0049A1.9977 1.9977 0 006 30H26a2 2 0 002-2h0V24zM6 12L7.411 13.405 15 5.825 15 24 17 24 17 5.825 24.591 13.405 26 12 16 2 6 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Export.propTypes = iconPropTypes;
}

export { DirectionRotaryFirstRight, DirectionRotaryFirstRightFilled, DirectionRotaryRight, DirectionRotaryRightFilled, DirectionRotaryStraight, DirectionRotaryStraightFilled, DirectionSharpTurn, DirectionSharpTurnFilled, DirectionStraight, DirectionStraightFilled, DirectionStraightRight, DirectionStraightRightFilled, DirectionUTurn, DirectionUTurnFilled, DirectoryDomain, DistributeHorizontalCenter, DistributeHorizontalLeft, DistributeHorizontalRight, DistributeVerticalBottom, DistributeVerticalCenter, DistributeVerticalTop, DnsServices, Doc, Document, DocumentAdd, DocumentAttachment, DocumentAudio, DocumentBlank, DocumentDownload, DocumentEpdf, DocumentExport, DocumentHorizontal, DocumentImport, DocumentMultiple_01, DocumentMultiple_02, DocumentPdf, DocumentPreliminary, DocumentProtected, DocumentSecurity, DocumentSentiment, DocumentSigned, DocumentSketch, DocumentSubtract, DocumentTasks, DocumentUnknown, DocumentUnprotected, DocumentVertical, DocumentVideo, DocumentView, DocumentWordProcessor, DocumentWordProcessorReference, DogWalker, DotMark, DoubleInteger, DownToBottom, Download, Downstream, DragHorizontal, DragVertical, Draggable, Draw, DrillBack, DrillDown, DrillThrough, Drink_01, Drink_02, DriverAnalysis, Drone, DroneDelivery, DroneFront, DroneVideo, DropPhoto, DropPhotoFilled, Drought, Dvr, Earth, EarthAmericas, EarthAmericasFilled, EarthEuropeAfrica, EarthEuropeAfricaFilled, EarthFilled, EarthSoutheastAsia, EarthSoutheastAsiaFilled, Earthquake, EdgeCluster, EdgeDevice, EdgeNode, EdgeNodeAlt, EdgeService, Edit, EditOff, EdtLoop, Education, Email, EmailNew, Encryption, EnergyRenewable, Enterprise, EqualApproximately, Equalizer, Erase, Error, ErrorFilled, ErrorOutline, Event, EventChange, EventIncident, EventSchedule, EventWarning, Events, EventsAlt, ExamMode, ExecutableProgram, Exit, ExpandAll, ExpandCategories, Explore, Export, WatsonHealthDna, WatsonHealthDownloadStudy, WatsonHealthEdgeEnhancement, WatsonHealthEdgeEnhancement_01, WatsonHealthEdgeEnhancement_02, WatsonHealthEdgeEnhancement_03, WatsonHealthErase_3D };
